import { IEntity, IEquatable } from './entity';
import { ILocalizable } from './localized';

export type ILabel = IEntity & {
  id: IEquatable;
  text?: ILocalizable;
};
